<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //ValidasiKedatanganTruck
  { path: '/dashboard/validasi-kedatangan-truck', font: 'normal normal normal 16px/25px Poppins' , icon: 'far fa-truck-container', title: 'Validasi Ked. Truck' },

  //Activities
  { path: '/dashboard/pengecekan', icon: 'far fa-clipboard-check', title: 'Pengecekan TO', font: 'normal normal normal 16px/25px Poppins' },

  //Consumer Insights
  // { path: '/dashboard/consumer-insights', icon: 'far fa-users', title: 'Consumer Insight' },

  //Pengiriman
  { path: '/dashboard/pengiriman', icon: 'far fa-truck', title: 'Pengiriman', font: 'normal normal normal 16px/25px Poppins' },

  //Monitoring
  { path: '/dashboard/monitoring', icon: 'fas fa-desktop', title: 'Monitoring', font: 'normal normal normal 16px/25px Poppins',
    children: [
      { path: '/dashboard/monitoring/status-truk', title: 'Status Truk' },
      { path: '/dashboard/monitoring/status-sj', title: 'Status SJ' },
      { path: '/dashboard/monitoring/status-to', title: 'Status TO' },
      { path: '/dashboard/monitoring/transfer-to', title: 'Transfer TO' },
      { path: '/dashboard/monitoring/history-transfer-to', title: 'Riwayat Transfer TO' },
      { path: '/dashboard/monitoring/monitoring-kuli', title: 'Monitoring Kuli' }
    ]
  },
  //Report
  { path: '/dashboard/report', icon: 'far fa-file-alt', title: 'Report', font: 'normal normal normal 16px/25px Poppins'},

  //Truck Tracking
  { path: '/dashboard/truck-tracking', icon: 'far fa-truck', title: 'Truck Tracking', font: 'normal normal normal 16px/25px Poppins'},

  //Pengecekan Truck
  { path: '/dashboard/pengecekan-truck', icon: 'far fa-clipboard-check', title: 'Pengecekan Truck', font: 'normal normal normal 16px/25px Poppins', type: 'ADMIN' },

  //Riwayat Pengiriman
  { path: '/dashboard/riwayat-pengiriman', icon: 'fas fa-history', title: 'Riwayat Pengiriman', font: 'normal normal normal 16px/25px Poppins' },

  //Settings
  { path: '/dashboard/settings', icon: 'fas fa-cog', title: 'Settings', font: 'normal normal normal 16px/25px Poppins',
    children: [
      { path: '/dashboard/settings/user-mobile', icon: 'fas fa-user', title: 'User Driver Security', type: "GUDANG"},
      { path: '/dashboard/settings/user-management', icon: 'fas fa-user', title: 'User Management', type: "ADMIN"},
      { path: '/dashboard/settings/dealer-status', icon: 'fas fa-home-alt', title: 'Dealer Status', type:"ADMIN"},
      { path: '/dashboard/settings/nopol-truck', icon: 'far fa-truck', title: 'NOPOL Truck', type:"ADMIN"},
      { path: '/dashboard/settings/kuli', icon: 'fas fa-user-friends', title: 'Kuli', type:"ADMIN"},
      { path: '/dashboard/settings/user-ekspedisi', icon: 'fas fa-home-alt', title: 'User Ekspedisi', type:"ADMIN"},
      { path: '/dashboard/settings/user-question', icon: 'far fa-comment-dots', title: 'User Question Truck', type:"ADMIN" },
      { path: '/dashboard/settings/user-officer', icon: '', title: 'User Officer', type: "ADMIN" },
      { path: '/dashboard/settings/master-container', icon: '', title: 'Jenis Truck', type: "ADMIN" }
    ]
  }

  //CSO
  // { path: '/cso', icon: 'fas fa-table', title: 'CSO',
  //   children: [
  //     { path: '/cso/exit-permit', title: 'Gatepass' },
  //     { path: '/cso/customer-quotation', title: 'Quotation' },
  //     { path: '/cso/insurance-policy', title: 'Insurance Policy' },
  //     { path: '/cso/master-data', title: 'Master Data',
  //       children: [
  //         { path: '/cso/master-data/color', title: 'Warna Mobil' },
  //         { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
  //         { path: '/cso/master-data/customer', title: 'Pelanggan' },
  //         { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
  //         { path: '/cso/master-data/laborer', title: 'Pekerja' },
  //         { path: '/cso/master-data/supplier', title: 'Supplier' },
  //       ]
  //     },
  //   ]
  // },
]

export default sidebarMenu;
</script>
